<template>
  <div class="time">
    <el-date-picker v-model="timeValue" type="datetimerange" :editable="false" :shortcuts="shortcuts"
                    range-separator="-" value-format="x" :start-placeholder="placeholder + '开始时间'"
                    :end-placeholder="placeholder + '结束时间'" @change="handleChange" />
  </div>
</template>

<script>
export default {
  name: "YmDateTimeRange",
};
</script>
<script setup>
import { ElDatePicker } from "element-plus";
import 'element-plus/dist/index.css'
import { ref, defineProps,defineEmits, watch } from "vue";
import {NumberDiv, NumberMul} from "ym-js-box";
const emits = defineEmits(["update:modelValue","update:startValue","update:endValue"]);

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  startValue:{
    type: [Number,String],
    default: ''
  },
  endValue:{
    type: [Number,String],
    default: ''
  }
})

const shortcuts = [
  {
    text: '一周',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      return [start, end]
    },
  },
  {
    text: '一个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      return [start, end]
    },
  },
  {
    text: '3个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      return [start, end]
    },
  },
]

const selectValueDeal = () => {
  return !props.startValue || !props.endValue ? (props.endValue ? [NumberMul(props.endValue,1000)] : (props.startValue ? [NumberMul(props.startValue,1000)] : '')) :  [NumberMul(props.startValue,1000),NumberMul(props.endValue,1000)]
}
const timeValue = ref(selectValueDeal())
const is_select = ref(false)

watch(() => props.startValue, (newValue, oldVal) => {
  if (!is_select.value && newValue) {
    timeValue.value = selectValueDeal()
  }
}, { immediate: true, deep: true })
watch(() => props.endValue, (newValue, oldVal) => {
  if (!is_select.value && newValue) {
    timeValue.value = selectValueDeal()
  }
}, { immediate: true, deep: true })

const handleChange = (value) => {
  console.log(value,props)
  emits("update:startValue", value ? NumberDiv(value[0], 1000, 0) : 0)
  emits("update:endValue", value ? NumberDiv(value[1], 1000, 0) : 0)
}
</script>

<style scoped>
.time {
  display: inline-block;
}
</style>
